import { useAuthStore } from "@/stores/auth.store";
import { createRouter, createWebHistory } from "vue-router";
import routes from "./routers";

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore();
  const requiresAuth = to.meta.requiresAuth;
  const requiresAdmin = to.meta.requiresAdmin;

  if (!authStore.isInitialized) {
    try {
      await authStore.initializeAuth();
    } catch (error) {
      console.warn("[Router] Auth initialization failed:", error.message);
    }
  }

  if (
    authStore.isAuthenticated &&
    to.name !== "Login" &&
    to.name !== from.name &&
    to.meta.requiresAuth
  ) {
    authStore.fetchUser().catch((error) => {
      console.warn("[Router] Erro ao atualizar dados do usuário:", error);
    });
  }

  if (to.name === "Login" && authStore.isAuthenticated) {
    return next({ name: "Home" });
  }

  if (requiresAuth && !authStore.isAuthenticated) {
    return next({ name: "Login" });
  }

  if (requiresAdmin && !authStore.isAdmin) {
    console.warn("[Router] Access denied: Admin role required for", to.path);
    console.warn("[Router] User roles:", authStore.userRoles);
    console.warn("[Router] isAdmin:", authStore.isAdmin);
    return next({ name: "Home" });
  }

  return next();
});

export default router;
